export interface StoreProductState {
    readonly selected: boolean;
    readonly locked: boolean;
    readonly inBundle: boolean;
    readonly hasTrialAvailable: boolean;
}

export function BundleProduct(): StoreProductState {
    return {
        selected: true,
        locked: false,
        inBundle: true,
        hasTrialAvailable: false
    };
}

export type StoreProductStates<T extends string> = {
    [K in T]: StoreProductState;
};
